import { configObj, ConfigObj } from "./globalConfig";

const useServerLocally = false;
const serverURLProd = "https://app.washtrack.ro";
const serverURLStage = "https://triple-s-stage-052985a66c36.herokuapp.com";

const getServerURL = (configObj: ConfigObj) => configObj.isStage ? serverURLStage : serverURLProd;

export const getReqUrl = (_configObj = configObj): string => {
    const IS_PROD = process.env.NODE_ENV === "production";
    const URL = IS_PROD ? getServerURL(_configObj) : (useServerLocally ? getServerURL(_configObj) : "http://localhost:5003");

    return URL;
}
